import { useEffect, useState } from 'react';
import LiveStatusLabel from '@/components/LiveStatusLabel';
import { fetchScoreboardData } from '@/services/api';
import PhotoAPI from '@/services/photo-api';
import { type IMatchHeader } from '@/types/INote';
import styles from './index.module.scss';

export default function LiveSportScoreboard ({
  matchHeader,
  xx,
}: {
  matchHeader?: IMatchHeader;
  xx: string;
}) {
  const [localMatchHeader, setLocalMatchHeader] = useState<IMatchHeader>();

  useEffect(() => {
    fetchScoreboardData({ articleId: xx })
      .then((response) => setLocalMatchHeader(response.matchHeaders[0]))
      .catch(() => {
        /* Do nothing */
      });
  }, []);

  const activeMatchHeader = matchHeader ?? localMatchHeader;

  if (!activeMatchHeader) {
    return null;
  }

  return (
    <div className={styles['live-sport-scoreboard']} data-e='scoreboard'>
      <div className={styles['live-sport-scoreboard-team']} data-e='scoreboard-panel'>
        <img
          alt={activeMatchHeader.teamLeft.name}
          className={styles['live-sport-scoreboard-team__logo']}
          data-e='scoreboard-img'
          src={PhotoAPI.photoFromXX(activeMatchHeader.teamLeft.imageId.toString(), 'J', 'jpg')}
        />
        <span className={styles['live-sport-scoreboard-team__name']} data-e='scoreboard-team'>
          {activeMatchHeader.teamLeft.name}
        </span>
      </div>
      <div className={styles['live-sport-scoreboard-metadata']} data-e='scoreboard-wrapper'>
        <LiveStatusLabel />
        <div className={styles['live-sport-scoreboard-metadata__score']} data-e='scoreboard-score'>
          {activeMatchHeader.scoreMain}
        </div>
        <div className={styles['live-sport-scoreboard-metadata__details']} data-e='scoreboard-details'>
          {activeMatchHeader.scoreDetails}
        </div>
      </div>
      <div className={styles['live-sport-scoreboard-team']} data-e='scoreboard-panel'>
        <img
          alt={activeMatchHeader.teamRight.name}
          className={styles['live-sport-scoreboard-team__logo']}
          data-e='scoreboard-img'
          src={PhotoAPI.photoFromXX(activeMatchHeader.teamRight.imageId.toString(), 'J', 'jpg')}
        />
        <span className={styles['live-sport-scoreboard-team__name']} data-e='scoreboard-team'>
          {activeMatchHeader.teamRight.name}
        </span>
      </div>
    </div>
  );
}
